export default __webpack_public_path__ + "static/media/2408241.824c72cd.webp";